import React, { useState } from 'react';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import PatientProfileEditModal from './PatientProfileEditModal';
import {
	useLazyPatientProfileDataQuery,
	User,
} from '../../../../graphql/graphql';
import { useEffectAsync } from '../../../../helpers';

interface Props {
	user?: User;
	userId?: string;
	onSuccess: () => void;
	childId?: string;
}

const PatientProfileEditButton: React.FC<Props> = ({
	user: primaryUser,
	userId,
	onSuccess,
	childId,
}) => {
	const [getPatientProfile] = useLazyPatientProfileDataQuery();
	const [user, setUser] = useState<User | undefined>(primaryUser);
	const [isPatientEditModalOpen, setIsPatientEditModalOpen] = useState(false);

	const handleOpenEditModal = async () => {
		if (!user && userId) {
			const result = await getPatientProfile({
				userId,
				useOriginalId: true,
			}).unwrap();
			if (result?.user) {
				setUser(result?.user as User);
			}
		}
		setIsPatientEditModalOpen(true);
	};
	const handleOnCloseModal = () => {
		setUser(undefined);
		setIsPatientEditModalOpen(false);
	};

	const handleOnSuccess = () => {
		onSuccess();
		setUser(undefined);
		setIsPatientEditModalOpen(false);
	};

	return (
		<>
			<LinkButton
				title={
					childId
						? 'component.patientProfileEdit.editLegalRepresentative'
						: 'component.patientProfileEdit.button'
				}
				theme={Theme.BLUE}
				onClick={handleOpenEditModal}
			/>
			{isPatientEditModalOpen && user && (
				<PatientProfileEditModal
					user={user}
					isOpened
					onClose={handleOnCloseModal}
					onSuccess={handleOnSuccess}
					childId={childId}
				/>
			)}
		</>
	);
};

export default PatientProfileEditButton;
